import { useState } from 'react';
import { FormControlLabel, Grid, Switch } from '@mui/material';
import CustomDialog from 'components/CustomDialog';

export default function ColumnSettings({ columns, visibility, onSave, onClose }) {
  const [draft, setDraft] = useState(visibility);
  return <CustomDialog open title="DISPLAY_SETTINGS" onClose={onClose} closeBtn="CLOSE" width={900} maxWidth="95vw" contentPadding={1}
    actionBtn={{ title: 'SAVE', onClick: () => { onSave(draft); onClose(); } }}>
    <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ py: 1, minWidth: 0 }}>
      {columns.map(column => <Grid item xs={6} md={4} key={column.field} sx={{ minWidth: 0 }}><FormControlLabel label={column.headerName}
        sx={{ m: 0, width: '100%', alignItems: 'center', '& .MuiFormControlLabel-label': { minWidth: 0, overflowWrap: 'anywhere', fontSize: { xs: '0.8rem', sm: '0.9rem' } } }}
        control={<Switch checked={column.field === 'name' || draft[column.field] !== false} disabled={column.field === 'name'}
          onChange={event => setDraft(previous => ({ ...previous, [column.field]: event.target.checked }))} />} /></Grid>)}
    </Grid>
  </CustomDialog>;
}
